export const menuData = {
  tapas: {
    title_fr: "TAPAS",
    title_en: "TAPAS",
    description_fr: "À partager",
    description_en: "To share",
    content: [
      {
        name_fr: "PALLINA",
        name_en: "PALLINA",
        description_fr: "Mini-calzones, tomates, mozzarella",
        description_en: "Mini-calzones with tomatoes and mozzarella",
        subContent: [
          {
            quantity: null,
            price: 10.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CIABATTA",
        name_en: "CIABATTA",
        description_fr: "Pain à l’ail, tomates séchées, bresaola et mozzarella",
        description_en:
          "Garlic bread with sun-dried tomatoes, bresaola and mozzarella",
        subContent: [
          {
            quantity: null,
            price: 11.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "O'PTIT RITAL",
        name_en: "O'PTIT RITAL",
        description_fr:
          "Charcuterie italienne, fromages, légumes grillés",
        description_en:
          "Italian cold cuts, cheeses, grilled vegetables",
        // person_fr: "personne",
        // person_en: "person",
        subContent: [
          {
            quantity: null,
            price: 19,
            // perPerson: true,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "STRACCIATELLA",
        name_en: "STRACCIATELLA",
        description_fr: "Servi avec une Focaccia maison",
        description_en: "Served with a homemade focaccia",
        subContent: [
          {
            quantity: null,
            price: 9.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CAVIAR D’AUBERGINE",
        name_en: "EGGPLANT CAVIAR",
        description_fr: "Servi avec une Focaccia maison",
        description_en: "Served with a homemade focaccia",
        subContent: [
          {
            quantity: null,
            price: 8.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "GUACAMOLE",
        name_en: "GUACAMOLE",
        description_fr: "Servi avec une Focaccia maison",
        description_en: "Served with a homemade focaccia",
        subContent: [
          {
            quantity: null,
            price: 8.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CREVETTES À L’ITALIENNE",
        name_en: "ITALIAN SHRIMP",
        description_fr: "Servi avec une Focaccia maison",
        description_en: "Served with a homemade focaccia",
        subContent: [
          {
            quantity: null,
            price: 12,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  antipasti: {
    title_fr: "ENTRÉES",
    title_en: "ANTIPASTI",
    description_fr: "Les entrées",
    description_en: "The starters",
    content: [
      {
        name_fr: "BURRATINA",
        name_en: "BURRATINA",
        description_fr: "Burratina, mesclun, tomates cerises, oignons rouges",
        description_en: "Burratina, mesclun, cherry tomatoes, red onions",
        subContent: [
          {
            quantity: null,
            price: 10.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "MELON AL PROCHUTTO",
        name_en: "MELON AL PROSCIUTTO",
        description_fr:
          "Melon et son jambon cru italien, mozzarella, réduction de porto rouge",
        description_en:
          "Melon with Italian cured ham, mozzarella and red port reduction",
        subContent: [
          {
            quantity: null,
            price: 10,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CEVICHE DE BAR",
        name_en: "SEA BASS CEVICHE",
        description_fr:
          "Bar coupé finement, réduction d'orange et pamplemousse frais",
        description_en:
          "Finely cut sea bass, orange reduction and fresh grapefruit",
        subContent: [
          {
            quantity: null,
            price: 12.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "SAUMON GRAVLAX",
        name_en: "GRAVLAX SALMON",
        description_fr:
          "Saumon gravlax et sa sauce gravlax (format plat disponible)",
        description_en:
          "Gravlax salmon and its gravlax sauce (platter format available)",
        subContent: [
          {
            quantity: null,
            price: 11,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  pasta: {
    title_fr: "LA PASTA",
    title_en: "LA PASTA",
    description_fr:
      "Nos recettes de pâtes sauront ravir vos papilles par leur originalité et leurs nuances méditerranéennes",
    description_en:
      "Our pasta recipes will delight your taste buds with their originality and Mediterranean nuances",
    content: [
      {
        name_fr: "TRUFFINA",
        name_en: "TRUFFINA",
        description_fr: "Raviolis quatre fromages à la crème de truffe noire et parmesan AOP affiné 12 mois",
        description_en: "4-cheese ravioli with black truffle cream and parmesan AOP aged 12 months",
        subContent: [
          {
            quantity: null,
            price: 20.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CARBONARA",
        name_en: "CARBONARA",
        description_fr:
          "Rigatoni, guanciale croustillant, creme de pecorino Pepato de Sicile & jaune d’oeuf",
        description_en: "Rigatoni with crispy guanciale, pecorino Pepato de Sicile cream and egg yolk",
        subContent: [
          {
            quantity: null,
            price: 18.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "ALMATRIDIAVOLA",
        name_en: "ALMATRIDIAVOLA",
        description_fr:
          "Sauce tomate, Spianata piquante, oignon rouges, Pecorino Pepato, tomate cerise et roquette",
        description_en:
          "Tomato sauce, spicy salami, red onions, Pecorino Pepato, cherry tomatoes and arugula",
        subContent: [
          {
            quantity: null,
            price: 19.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: true,
      },
      {
        name_fr: "CRUDO VERDE",
        name_en: "CRUDO VERDE",
        description_fr:
          "Pesto de basilique, jambon cru italien, stracciatella, oignons rouges et tomates cerises, crème de balsamique (chaud ou froid)",
        description_en:
          "Basil pesto, Italian cured ham, stracciatella, red onions and cherry tomatoes, balsamic cream (hot or cold)",
        subContent: [
          {
            quantity: null,
            price: 19.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "GAMBERRI ZUCCHINI LIMONI",
        name_en: "GAMBERRI ZUCCHINI LIMONI",
        description_fr:
          "Linguine à l'ail, crevettes, courgettes grillées, réduction de citron jaune et zeste de citron vert",
        description_en:
          "Linguine with garlic, shrimp, grilled zucchini, yellow lemon reduction and lime zest",
        subContent: [
          {
            quantity: null,
            price: 22.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      // {
      //   name_fr: "PASTA SAVOYARDE",
      //   name_en: "SAVOYARD PASTA",
      //   description_fr:
      //     "La recette classique de la tartiflette mais en version PASTA !",
      //   description_en:
      //     "The classic recipe of tartiflette but in PASTA version!",
      //   subContent: [
      //     {
      //       quantity: null,
      //       price: 19.5,
      //     },
      //   ],
      //   vegetarian: false,
      //   bio: false,
      //   spicy: false,
      // },
      {
        name_fr: "PASTA BAMBINO",
        name_en: "KIDS’ PASTA",
        description_fr: "Pour les moins de 12 ans (tomate, carbonara…) avec une boule de glace (+3€)",
        description_en: "For 12 years old and under (tomato, carbonara…) with a scoop of ice cream (+3€)",
        subContent: [
          {
            quantity: null,
            price: 10.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "Extra burrata entière",
        name_en: "Extra whole burrata",
        description_fr: "",
        description_en: "",
        subContent: [
          {
            quantity: null,
            price: 3.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  insalata: {
    title_fr: "INSALATA",
    title_en: "INSALATA",
    description_fr: "Salades bar",
    description_en: "Salad bar",
    content: [
      {
        name_fr: "CESARO ORIGINAL",
        name_en: "THE CESARO",
        description_fr: "Mesclun, poulet mariné, gressini, sauce César",
        description_en: "Mesclun, marinated chicken, grissini, Caesar dressing",
        subContent: [
          {
            quantity: null,
            price: 18.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "PRIMAVERA",
        name_en: "THE PRIMAVERA",
        description_fr: "Mesclun, légumes du moment, burratina",
        description_en: "Mesclun, seasonal vegetables, burratina",
        subContent: [
          {
            quantity: null,
            price: 17.5,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      // {
      //   name_fr: "TERRA COCCRANTE",
      //   name_en: "TERRA COCCRANTE",
      //   description_fr:
      //     "Bresaola, courgette marinée, ricotta citronnée, noisette, mesclun",
      //   description_en:
      //     "Bresaola, marinated zucchini with lemon ricotta, hazelnuts, and mesclun",
      //   subContent: [
      //     {
      //       quantity: null,
      //       price: 17.5,
      //     },
      //   ],
      //   vegetarian: false,
      //   bio: false,
      //   spicy: false,
      // },
      {
        name_fr: "PROSCIUTTO CRUDO",
        name_en: "PROSCIUTTO CRUDO",
        description_fr:
          "Jambon San Daniele, mesclun, burratina, tomates cerises et séchées, parmesan",
        description_en:
          "San Daniele ham, mesclun, burratina, cherry tomatoes and dried tomatoes, parmesan",
        subContent: [
          {
            quantity: null,
            price: 18.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "OCEANE",
        name_en: "THE OCEAN",
        description_fr:
          "Tartare de saumon, mesclun, tomates cerises, oignons rouges",
        description_en:
          "Tartare of salmon, mesclun, cherry tomatoes, red onions",
        subContent: [
          {
            quantity: null,
            price: 19,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  specialita: {
    title_fr: "SPECIALITA DELLA CASA",
    title_en: "SPECIALITA DELLA CASA",
    description_fr: "Les spécialités de la Maison",
    description_en: "House specialties",
    content: [
      {
        name_fr: "TAGLIATA DI MANZO",
        name_en: "TAGLIATA DI MANZO",
        description_fr:
          "Boeuf grillé tranché minute, roquette fraiche, parmesan AOP affiné 12 mois, filet de pesto maison et p. d. t grenailles roties",
        description_en:
          "Sliced grilled beef with fresh arugula, parmesan AOP aged 12 months, homemade pesto and roasted baby potatoes",
        subContent: [
          {
            quantity: null,
            price: 27.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "MILANAISE OJS",
        name_en: "OJS MILANAISE",
        description_fr:
          "Escalope de poulet panée gratinée à la mozzarella, jambon cru italien, réduction de balsamique et garniture au choix",
        description_en:
          "Breaded chicken escalope gratinated with mozzarella, Italian cured ham, balsamic reduction and choice of garnish",
        subContent: [
          {
            quantity: null,
            price: 22.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CARPACCIO",
        name_en: "CARPACCIO",
        description_fr:
          "Fine tranches de bœuf, burrata entière, légumes grillés, roquette, tomates cerises, oignons rouges, filet de pesto maison et parmesan AOP affiné 12 mois",
        description_en:
          "Sliced beef, whole burrata, grilled vegetables, arugula, cherry tomatoes, red onions, homemade pesto and parmesan AOP aged 12 months",
        subContent: [
          {
            quantity: null,
            price: 19.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "LASAGNE DELA CASA",
        name_en: "LASAGNE DE LA CASA",
        description_fr: "Lasagne maison à la bolognaise mijotée longuement, gratinée au four à la mozzarella et parmesan AOP affiné 12 mois",
        description_en: "Lasagne with Bolognese sauce cooked for a long time, baked in the oven with mozzarella and parmesan AOP aged 12 months",
        subContent: [
          {
            quantity: null,
            price: 17.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      // {
      //   name_fr: "BURGER À L’ITALIENNE",
      //   name_en: "ITALIAN BURGER",
      //   description_fr:
      //     "Boeuf haché, tomates séchées, sauce gorgonzola au miel, mozzarella et pommes de terre grenaille",
      //   description_en:
      //     "Minced beef, sun-dried tomatoes, gorgonzola honey sauce, mozzarella and baby potatoes",
      //   subContent: [
      //     {
      //       quantity: null,
      //       price: 21.0,
      //     },
      //   ],
      //   vegetarian: false,
      //   bio: false,
      //   spicy: false,
      // },
      {
        name_fr: "PÊCHE DU MARCHÉ",
        name_en: "CATCH OF THE DAY",
        description_fr: "Poisson frais selon arrivage accompagné de légumes de saison (prix ajustable)",
        description_en: "Fresh fish according to availability accompanied by seasonal vegetables (price adjustable)",
        subContent: [
          {
            quantity: null,
            price: 22.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "Garniture supplémentaire",
        name_en: "Additional topping",
        description_fr: "Pasta à l'ail, légumes du moment ou pommes de terre grenaille",
        description_en: "Pasta with garlic, seasonal vegetables or baby potatoes",
        subContent: [
          {
            quantity: null,
            price: 4.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  pizze: {
    title_fr: "PIZZE",
    title_en: "PIZZE",
    description_fr: "A la romana maturée 48 à 72h, farine italienne et selection de produits venu d'Italie",
    description_en: "A la romana matured 48 to 72 hours, Italian flour and selection of products from Italy",
    content: [
      {
        name_fr: "MARGHERITA",
        name_en: "MARGHERITA",
        description_fr:
          "Sauce tomate, mozzarella fior di latte et basilic frais",
        description_en:
          "Tomato sauce, mozzarella fior di latte and fresh basil",
        subContent: [
          {
            quantity: "15 cm",
            price: 9,
          },
          {
            quantity: "30 cm",
            price: 12,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "REGINA",
        name_en: "REGINA",
        description_fr:
          "Tomate, jambon cuit supérieur, champignons, olives, artichauts marinés, ciboulette et mozzarella",
        description_en:
          "Tomato, superior cooked ham, mushrooms, olives, marinated artichokes, chives and mozzarella",
        subContent: [
          {
            quantity: "15 cm",
            price: 14,
          },
          {
            quantity: "30 cm",
            price: 16,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "FORMAGGI",
        name_en: "4 FROMAGGI",
        description_fr:
          "Tomate, chèvre, gorgonzola, parmesan AOP affiné 12 mois et mozzarella",
        description_en:
          "Tomato, goat cheese, gorgonzola, parmesan AOP aged 12 months and mozzarella",
        subContent: [
          {
            quantity: "15 cm",
            price: 14,
          },
          {
            quantity: "30 cm",
            price: 16,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CALZONE",
        name_en: "CALZONE",
        description_fr: "Soufflé à la tomate, jambon cuit supérieur, œuf, mozzarella",
        description_en:
          "Tomato-sauced soufflé with superior cooked ham, egg and mozzarella",
        subContent: [
          {
            quantity: "30 cm",
            price: 17,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "SAN DANIELE",
        name_en: "SAN DANIELE",
        description_fr:
          "Tomate, jambon cru italien, roquette, tomates cerises, parmesan AOP affiné 12 mois et réduction de balsamique",
        description_en:
          "Tomato, Italian cured ham, arugula, cherry tomatoes, parmesan AOP aged 12 months and balsamic reduction",
        subContent: [
          {
            quantity: "15 cm",
            price: 15,
          },
          {
            quantity: "30 cm",
            price: 18,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "DIAVOLA",
        name_en: "DIAVOLA",
        description_fr:
          "Tomate, Spianata piquante, oignon rouges, roquette et Pecorino Pepato Sicilien",
        description_en:
          "Tomato, spicy salami, red onions, arugula and Pecorino Pepato Sicilian",
        subContent: [
          {
            quantity: "15 cm",
            price: 15,
          },
          {
            quantity: "30 cm",
            price: 18,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: true,
      },
      {
        name_fr: "POLLO",
        name_en: "POLLO",
        description_fr: "Tomate , poulet, chèvre, miel et mozzarella",
        description_en: "Tomato, chicken, goat cheese, honey and mozzarella",
        subContent: [
          {
            quantity: "15 cm",
            price: 15,
          },
          {
            quantity: "30 cm",
            price: 18,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "AVOCADO",
        name_en: "AVOCADO",
        description_fr:
          "Crème fraiche, jambon cru Italien, poulet, avocat, oignons rouges, tomates cerises et mozzarella",
        description_en:
          "Cream, Italian cured ham, chicken, avocado, red onions, cherry tomatoes and mozzarella",
        subContent: [
          {
            quantity: "15 cm",
            price: 16,
          },
          {
            quantity: "30 cm",
            price: 21,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "VEGE",
        name_en: "VEGETARIAN",
        description_fr: "Caviar d’aubergine, légumes de saison, roquette et buratina entière",
        description_en: "Eggplant caviar, seasonal vegetables, arugula and whole buratina",
        subContent: [
          {
            quantity: "15 cm",
            price: 16,
          },
          {
            quantity: "30 cm",
            price: 20,
          },
        ],
        vegetarian: true,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "BRESAOLA",
        name_en: "BRESAOLA",
        description_fr: "Sauce tomate, bresaola, roquette, burrata entière et parmesan AOP affiné 12 mois",
        description_en: "Tomato sauce, bresaola, arugula, whole burrata and parmesan AOP aged 12 months",
        subContent: [
          {
            quantity: "15 cm",
            price: 16,
          },  
          {
            quantity: "30 cm",
            price: 21,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "SALMONE",
        name_en: "SALMON",
        description_fr: "Sauce tomate , guacamole maison, saumon, roquette et burrata entière",
        description_en: "Tomato sauce, homemade guacamole, salmon, arugula and whole burrata",
        subContent: [
          {
            quantity: "15 cm",
            price: 17,
          },
          {
            quantity: "30 cm",
            price: 22,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "TARTUFO",
        name_en: "TARTUFO",
        description_fr:
          "Crème de truffe noire, jambon cru Italien, tomates cerises, roquette et parmesan AOP affiné 12 mois",
        description_en:
          "Truffle cream, parmesan, San Daniele ham and cherry tomatoes",
        subContent: [
          {
            quantity: "15 cm",
            price: 17,
          },
          {
            quantity: "30 cm",
            price: 22,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "Supplément classique",
        name_en: "Classic supplement",
        description_fr: "",
        description_en: "",
        subContent: [
          {
            quantity: null,
            price: 1.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "Supplément premium",
        name_en: "Premium supplement",
        description_fr: "Burrata, charcuterie et saumon",
        description_en: "Burrata, cold cuts and salmon",
        subContent: [
          {
            quantity: null,
            price: 3.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },

  dessert: {
    title_fr: "DOUCEURS",
    title_en: "DESSERTS",
    description_fr: "Dolce",
    description_en: "Dolce",
    content: [
      {
        name_fr: "TIRAMISU CLASSICO",
        name_en: "CLASSICO TIRAMISU",
        description_fr: "Tiramisu au café",
        description_en: "Coffee tiramisu",
        subContent: [
          {
            quantity: null,
            price: 8.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "BRIOCHE PERDUE",
        name_en: "LOST BREAD",
        description_fr: "Brioche façon pain perdu, caramel et spéculoos et sa glace vanille",
        description_en: "French toast with caramel, speculoos and vanilla ice cream",
        subContent: [
          {
            quantity: null,
            price: 9.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "FONDANT CHOCOLAT",
        name_en: "CHOCOLATE FONDANT",
        description_fr: "Fondant chocolat tiède et creme fouetté et glace vanille",
        description_en: "Warm chocolate fondant and whipped cream and vanilla ice cream",
        subContent: [
          {
            quantity: null,
            price: 9.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "PANNA COTTA",
        name_en: "PANNA COTTA",
        description_fr: "Coulis de fruits rouges",
        description_en: "Red fruit coulis",
        subContent: [
          {
            quantity: null,
            price: 8.0,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CIABATTA NUTELLA",
        name_en: "CIABATTA NUTELLA",
        description_fr: "Pain pizza Nutella (à partager, ou pas !)",
        description_en: "Nutella pizza bread (to share, or not!)",
        subContent: [
          {
            quantity: null,
            price: 10.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "TARTE DU MOMENT",
        name_en: "MOMENT TART",
        description_fr: "Notre chef vous dévoile toutes ses reçettes",
        description_en: "Our chef reveals all his recipes",
        subContent: [
          {
            quantity: null,
            price: 7,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "CAFE SEGRETO",
        name_en: "SEGRETO COFFEE",
        description_fr: "Café accompagné de 3 gourmandises (thé +1€)",
        description_en: "Coffee served with 3 treats (tea +1€)",
        subContent: [
          {
            quantity: null,
            price: 9.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
      {
        name_fr: "BOULE DE GLACE",
        name_en: "ICE CREAM SCOOP",
        description_fr:
          "Vanille, chocolat, framboise, citron, café, pistache, mangue, noisette,…",
        description_en:
          "Vanilla, chocolate, raspberry, lemon, coffee, pistachio, mango, hazelnut,…",
        subContent: [
          {
            quantity: "2",
            price: 6.5,
          },
          {
            quantity: "3",
            price: 8.5,
          },
        ],
        vegetarian: false,
        bio: false,
        spicy: false,
      },
    ],
  },
};
